import { Box, Modal } from "@mui/material";
import React from "react";

const CircleIcon = (props) => {

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        // width: 400,
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        // pt: 2,
        // px: 4,
        // pb: 3,
    };

    const [open, setOpen] = React.useState(false);
    const handleClose = () => setOpen(false);

    return (


        <React.Fragment>

            {/* ——— CIRCULAR ICON ——— */}
            {/*<Box*/}
            {/*    onClick={handleOpen}*/}
            {/*    onMouseEnter={() => setHovered(true)}*/}
            {/*    onMouseLeave={() => setHovered(false)}*/}
            {/*    sx={{*/}
            {/*        height: 90,*/}
            {/*        width: 90,*/}
            {/*        borderRadius: "50%",*/}
            {/*        backgroundColor: hovered ? "#e3e3e3" : "#f5f5f5",*/}
            {/*        boxShadow: hovered ? 8 : 1,*/}
            {/*        display: "flex",*/}
            {/*        alignItems: "center",*/}
            {/*        justifyContent: "center",*/}
            {/*        cursor: "pointer",*/}
            {/*        transition: "all 0.25s ease",*/}
            {/*    }}*/}
            {/*>*/}
            {/*    /!* SVG / icon passed as children *!/*/}
            {/*    {props.children}*/}
            {/*</Box>*/}

            {props.children}
            {/* ——— MODAL ——— */}
            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="parent-modal-title"
                aria-describedby="parent-modal-description"
            >
                <Box sx={style}>
                    {props.children}
                </Box>
            </Modal>

        </React.Fragment>
    );
};

export default CircleIcon;